// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vault_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file vault_type.proto.
 */
export const file_vault_type: GenFile = /*@__PURE__*/
  fileDesc("ChB2YXVsdF90eXBlLnByb3RvEgZkb21haW4qqgIKCVZhdWx0VHlwZRIWChJWQVVMVF9UWVBFX1VOS05PV04QABITCg9WQVVMVF9UWVBFX01FVEEQARIWChJWQVVMVF9UWVBFX1BSSVZBVEUQAhITCg9WQVVMVF9UWVBFX1RFQU0QAxIYChRWQVVMVF9UWVBFX1RFQU1fTUVUQRAEEiQKIFZBVUxUX1RZUEVfT1JHQU5JWkFUSU9OX1BFUlNPTkFMEAYSFAoQVkFVTFRfVFlQRV9JTkJPWBAHEhkKFVZBVUxUX1RZUEVfSU5CT1hfTUVUQRAIEiEKHVZBVUxUX1RZUEVfT1JHQU5JWkFUSU9OX0FETUlOEAkSKQolVkFVTFRfVFlQRV9PUkdBTklaQVRJT05fTE9HSU5fU1VNTUFSWRAKIgQIBRAFQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.VaultType
 */
export enum VaultType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: VAULT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * this is checked by the vault_types_enum constraint, see ../migrations/0018_multi_user_vaults.up.sql (and other migrations)
   *
   * @generated from enum value: VAULT_TYPE_META = 1;
   */
  META = 1,

  /**
   * @generated from enum value: VAULT_TYPE_PRIVATE = 2;
   */
  PRIVATE = 2,

  /**
   * @generated from enum value: VAULT_TYPE_TEAM = 3;
   */
  TEAM = 3,

  /**
   * @generated from enum value: VAULT_TYPE_TEAM_META = 4;
   */
  TEAM_META = 4,

  /**
   * @generated from enum value: VAULT_TYPE_ORGANIZATION_PERSONAL = 6;
   */
  ORGANIZATION_PERSONAL = 6,

  /**
   * @generated from enum value: VAULT_TYPE_INBOX = 7;
   */
  INBOX = 7,

  /**
   * @generated from enum value: VAULT_TYPE_INBOX_META = 8;
   */
  INBOX_META = 8,

  /**
   * @generated from enum value: VAULT_TYPE_ORGANIZATION_ADMIN = 9;
   */
  ORGANIZATION_ADMIN = 9,

  /**
   * @generated from enum value: VAULT_TYPE_ORGANIZATION_LOGIN_SUMMARY = 10;
   */
  ORGANIZATION_LOGIN_SUMMARY = 10,
}

/**
 * Describes the enum domain.VaultType.
 */
export const VaultTypeSchema: GenEnum<VaultType> = /*@__PURE__*/
  enumDesc(file_vault_type, 0);

